export default function ListItemIcon() {
  return {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 32,
          paddingTop: 10,
          paddingBottom: 10,
        },
      },
    },
  };
}
